import React from 'react';
import { FireIcon, SparklesIcon, HeartIcon } from '@heroicons/react/24/outline';
import PlaylistTableModal from './PlaylistTableModal';
import FeelLuckyModal from './FeelLuckyModal';
import FeelLuckyInline from './FeelLuckyInline';
const FeelLuckyCarousel = () => {
  const options = [
    { 
      name: 'Hype', 
      description: 'From recent favorites',
      icon: FireIcon,
      time: 'short_term'
    },
    { 
      name: 'Balanced', 
      description: 'From mid-term favorites',
      icon: SparklesIcon,
      time: 'medium_term'
    },
    { 
      name: 'Evergreen', 
      description: 'From your all-time favorites',
      icon: HeartIcon,
      time: 'long_term'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 py-8">
      {options.map((option, index) => {
        const Icon = option.icon;
        return (
          <div 
            key={index}
            className="theme-card rounded-lg p-6 text-center"
          >
            <Icon className="h-12 w-12 mx-auto mb-4 text-[#FF9F1C]" />
            <h3 className="text-[#FF6B35] text-xl font-bold mb-2">{option.name}</h3>
            <p className="text-white mb-4">{option.description}</p>
            {/*}
            <PlaylistTableModal 
              linkText="Select" 
              list_id={`feellucky_${option.name.toLowerCase()}`} 
              list_name={option.name} 
              modalTitle={`${option.name} Playlist`} 
              width="90%" 
              height="90%" 
            />
            */}


             <FeelLuckyInline time={option.time} name={option.name} /> 
          </div>
        );
      })}
    </div>
  );
};

export default FeelLuckyCarousel;
